import React, { useState, useEffect } from "react";
import { utcToLocalDateTime } from "../../../utils/dateTimeUtils";
import { generateSessionZoomLink } from "../../services/sessionBookingService";

const SessionBookingTable = ({ bookings, onCancel }) => {
  const [loadingZoom, setLoadingZoom] = useState({}); // track loading per session
  const [localBookings, setLocalBookings] = useState(bookings);

  // Sync local state when bookings prop changes
  useEffect(() => {
    setLocalBookings(bookings);
  }, [bookings]);

  // Helper to show time with IST label
  const formatWithIST = (utcTime) =>
    utcTime ? `${utcToLocalDateTime(utcTime)} IST` : "N/A";

  /**
   * Generate Zoom link for a TimeTableSession
   */
  const handleGenerateLink = async (sessionId) => {
    setLoadingZoom((prev) => ({ ...prev, [sessionId]: true }));

    try {
      // ✅ Backend expects TimeTableSession ID
      const { data: zoomLink } = await generateSessionZoomLink(sessionId);

      // ✅ Update UI immediately
      setLocalBookings((prev) =>
        prev.map((b) =>
          b.sessionId === sessionId ? { ...b, zoomLink } : b
        )
      );
    } catch (error) {
      //console.error("Failed to generate Zoom link:", error);
      alert("Failed to generate Zoom link. Check console for details.");
    } finally {
      setLoadingZoom((prev) => ({ ...prev, [sessionId]: false }));
    }
  };

  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "15px",
      }}
    >
      <thead>
        <tr style={{ backgroundColor: "#f5f5f5" }}>
          <th style={th}>Session</th>
          <th style={th}>Booked At</th>
          <th style={th}>Start Time</th>
          <th style={th}>End Time</th>
          <th style={th}>Zoom Link</th>
          <th style={th}>Status</th>
          <th style={th}>Actions</th>
        </tr>
      </thead>

      <tbody>
        {localBookings.map((b) => (
          <tr key={b.id}>
            <td style={td}>{b.sessionTopic || "N/A"}</td>
            <td style={td}>{formatWithIST(b.bookedAt)}</td>
            <td style={td}>{formatWithIST(b.sessionStartTime)}</td>
            <td style={td}>{formatWithIST(b.sessionEndTime)}</td>

            <td style={td}>
              {b.zoomLink && b.zoomLink !== "null" ? (
                <a href={b.zoomLink} target="_blank" rel="noreferrer">
                  Join
                </a>
              ) : (
                <button
                  onClick={() => handleGenerateLink(b.sessionId)}
                  disabled={loadingZoom[b.sessionId]}
                >
                  {loadingZoom[b.sessionId]
                    ? "Generating..."
                    : "Generate Link"}
                </button>
              )}
            </td>

            <td style={td}>
              {b.canceled ? "❌ Cancelled" : "✅ Active"}
            </td>

            <td style={td}>
              {!b.canceled && (
                <button onClick={() => onCancel(b.id)}>Cancel</button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const th = {
  padding: "10px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const td = {
  padding: "10px",
  border: "1px solid #ddd",
};

export default SessionBookingTable;
